import { createFileRoute } from "@tanstack/react-router";

import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { ClientCoachedTrainings } from "@/features/coached-trainings/modules/client-coached-trainings/client-coached-trainings";
import { ClientTrainingPanel } from "@/features/client-training/modules/client-training-panel/client-training-panel";
import { TrainingPlanList } from "@/features/training-plans/modules/training-plan-list/training-plan-list";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/plans")({
  loader: () => ({ crumb: m.client_tab_plans() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId } = Route.useParams();
  return (
    <ClientTabPage clientId={clientId} tab="plans">
      <div className="grid gap-10">
        <TrainingPlanList clientId={clientId} />
        <ClientCoachedTrainings clientId={clientId} />
        <ClientTrainingPanel clientId={clientId} />
      </div>
    </ClientTabPage>
  );
}
